<template>
  <div>
    <div class="margin-top margin-left">
      <el-button size="mini" @click="getList()">查询</el-button>
    </div>
    <el-descriptions
      class="margin-top margin-left"
      :column="2"
      size="mini"
      border
    >
      <el-descriptions-item label="员工">
        <el-input v-model="data.userName" placeholder="请输入" />
      </el-descriptions-item>
    </el-descriptions>
    <el-table
      class="margin-top margin-left"
      max-height="600px"
      :data="list"
      border
    >
      <el-table-column label="员工姓名" prop="name" width="150" />
      <el-table-column label="登录账号" prop="username" width="150" />
      <el-table-column label="部门全称" prop="department_name" />
      <el-table-column label="可用短信" prop="usable_msg_num" width="120" />
      <el-table-column label="历史分配短信" prop="total_msg_num" width="200" />
      <el-table-column label="已发送短信" prop="send_msg_num" width="150" />
      <el-table-column label="操作" width="150">
        <template slot-scope="data">
          <el-link type="primary" :underline="false" @click="open(data.row.id)">
            修改
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="sizes, total, prev, pager, next"
      :total="totalCount"
      :current-page.sync="data.page"
      :page-size.sync="data.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      class="margin-top"
      style="float: right"
    />
    <el-dialog
      :visible.sync="visable"
      title="修改短信配额"
      width="30%"
      :before-close="closeDialog"
    >
      <el-form :model="form" label-width="80px">
        <el-form-item label="修改数量">
          <el-input-number v-model="form.num" size="mini"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="save()">保存</el-button>
          <el-button size="mini" @click="closeDialog()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "SmsUser",
  data() {
    return {
      data: { userName: "", page: 1, pageSize: 10 },
      list: [],
      totalCount: 0,
      visable: false,
      form: {
        id: 0,
        num: 0,
      },
    };
  },
  watch: {
    "data.page"(n, o) {
      this.getList();
    },
    "data.pageSize"(n, o) {
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.$myhttp
        .post("admin/SmsUser/getSmsUserList", this.data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((res) => {
          // 异步执行成功后
          this.list = res.data.data;
          this.totalCount = res.data.totalCount;
        });
    },
    closeDialog() {
      this.visable = false;
      this.form = {
        id: 0,
        num: 0,
      };
    },
    open(id) {
      this.visable = true;
      this.form.id = id;
    },
    save() {
      this.$myhttp
        .post("admin/SmsUser/saveMsgNum", this.form, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((res) => {
          // 异步执行成功后
          if (res.data.code == 200) {
            this.$message.success("保存成功");
            this.closeDialog();
            this.getList();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
  },
};
</script>

<style>
.margin-top {
  margin-top: 10px;
}
.margin-left {
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Admin/Butler/SmsUser.vue